import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {RmOrderService} from '../../services/rm-order.service';
import {Order} from '../../classes/order';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {RmConfirmationService} from '../../services/rm-confirmation.service';
import {RmShoppingCartService} from '../../services/rm-shopping-cart.service';
import {ConfirmDialogComponent} from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {AlertDialogComponent} from '../../../shared/components/alert-dialog/alert-dialog.component';
import {DigoService} from '../../../services/digo.service';
import { RmGlobals } from '../../classes/rm-globals';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-rm-confirmation',
    templateUrl: './rm-confirmation.component.html',
    styleUrls: ['./rm-confirmation.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmConfirmationComponent implements OnInit, OnDestroy {
    @Output() onActivationRequest = new EventEmitter<boolean>();

    public pdv;
    public order: Order;
    public typeOrder: string;
    public rateFtth: any = null;
    public ratesMobiles = [];
    public totalPrice = 0;
    public form: any;
    public isLoading = false;
    public activationError: any;
    public documentTypes;
    public date = new Date();
    public startGetStatusTime = 0;
    public disabledActivate: boolean = false;
    private allSubscription: Subscription[] = [];

    constructor(
        private rmService: RepublicaMovilService,
        private orderService: RmOrderService,
        private confirmationService: RmConfirmationService,
        private formBuilder: FormBuilder,
        private shoppingCart: RmShoppingCartService,
        public matDialog: MatDialog,
        private digoService: DigoService,
        private rmGlobals: RmGlobals
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            check1: [false],
            check2: [false, Validators.required],
        });
        this.allSubscription.push(this.rmService.getTypeOrder()
            .subscribe((data: any) => {
                this.typeOrder = data;
            })
        );

        this.allSubscription.push(this.rmService.getRateFtth()
            .subscribe((data: any) => {
                this.rateFtth = data;
                this.totalPrice = this.rmGlobals.updateTotalPrice(this.rateFtth, this.ratesMobiles);
            })
        );

        this.allSubscription.push(this.rmService.getRatesMobile()
            .subscribe((data: any) => {
                if (data != null) {
                    this.ratesMobiles = data;
                    this.totalPrice = this.rmGlobals.updateTotalPrice(this.rateFtth, this.ratesMobiles);
                }
            })
        );

        this.allSubscription.push(this.orderService.getOrder()
            .subscribe((data: any) => {
                this.order = data;
            })
        );

        this.allSubscription.push(this.rmService.getDocumentTypes()
            .subscribe((data: any) => {
                if (data) {
                    this.documentTypes = data;
                }
            })
        );

        this.allSubscription.push(this.digoService.getPDV()
            .subscribe(data => {
                if (data) {
                    this.pdv = data;
                }
            })
        );

        this.allSubscription.push(this.confirmationService.getDisableActivate()
            .subscribe(data => {
                this.disabledActivate = data;
            })
        );
    }

    priceWithIVA(price: number): number {
        return price * 1.21;
    }

    public errorHandling = (control: string, error: string) => {
        if (this.form.get(control).invalid && (this.form.get(control).dirty || this.form.get(control).touched)) {
            return this.form.controls[control].hasError(error);
        }
    }

    activate(type) {
        if (this.pdv.permissions.SAMPLE_MODE && this.pdv.permissions.SAMPLE_MODE === 'SAMPLE') {
            this.matDialog.open(AlertDialogComponent, {
                data: {message: 'Usuario demostración. No se puede finalizar el alta'}
            });
        } else {
            const keysArray = this.form instanceof FormGroup ? Object.values(this.form.controls) : this.form.controls;

            keysArray.forEach(control => {
                if (control instanceof FormControl) {
                    control.markAsTouched({onlySelf: false});
                    control.updateValueAndValidity();
                }
            });

            if (this.form.valid) {
                this.orderService.setAgreements(this.form.getRawValue());
                this.isLoading = true;
                let initialTime = new Date().getTime();
                this.activationError = null;
                this.onActivationRequest.emit(false);
                this.confirmationService.setHttpError(false);
                let info = {
                    trace: type + (navigator ? ('/' + navigator.userAgent) : ''),
                    timestamp: new Date().toISOString()
                }
                this.orderService.createOrder(false, info)
                    .subscribe((response: any) => {
                        this.startGetStatusTime = initialTime;
                    }, error => {
                        console.error('[CREATE ORDER - ACTIVATION]', error);
                        this.isLoading = false;
                        this.activationError = error;
                        this.onActivationRequest.emit(true);
                        this.confirmationService.setHttpError(true);
                    });
            }
        }
    }

    goToStep(index) {
        this.shoppingCart.getStepper().selectedIndex = index;
    }

    removeExtraLine(index) {
        this.matDialog
            .open(ConfirmDialogComponent, {
                data: {
                    title: 'Eliminar linea móvil adicional',
                    message: '¿Está seguro de querer eliminar la linea móvil adicional?'
                },
                panelClass: 'rm'
            })
            .afterClosed()
            .subscribe((confirm: boolean) => {
                if (confirm) {
                    this.orderService.removeOrder(index);
                    this.rmService.removeLine(index);
                    this.rmService.setIndexToRemove(index);
                    this.totalPrice = this.rmGlobals.updateTotalPrice(this.rateFtth, this.ratesMobiles);
                }
            });
    }

    public getDocumentLabel(id): string {
        if (this.documentTypes && this.documentTypes.length && id) {
            const found = this.documentTypes.find(x => x.document_type_id === +id);
            return found ? found.description : '';
        }
    }

    public preloadingComplete() {
        this.confirmationService.setFinished(true);
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
